import { ModalContext } from 'app/app';
import axios from 'axios';
import { Pagination } from 'components/Pagination';
import {
  Animate,
  Grid,
  Loader,
  Search,
  Table,
  ViewContext,
} from 'components/lib';
import DateUtils from 'helpers/dateUtils';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './styles.module.scss';

export function Onboarding(props) {
  const { id } = useParams();
  const [payload, setPayload] = useState();
  const [agencyData, setAgencyData] = useState({});
  const [typeFilter, setTypeFilter] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState('');

  const { setModal } = useContext(ModalContext);
  const context = useContext(ViewContext);

  const formatAgency = (agencyId) => {
    if (agencyId) {
      const agencyString = 'A000000';
      const count = agencyId.split(' ')[0].length;

      return (
        agencyString.substring(0, agencyString.length - count) +
        agencyId
      );
    }
  };

  async function runAPI(page, search, firstTime, typeFilter) {
    setLoading(true);

    await axios
      .get(
        `/api/document/admin?page=${page}&search=${searchQueryString}`
      )
      .then(async (res) => {
        setPayload(res.data.data);

        const helper = new DateUtils();
        const timezone = await helper.getTimezone();

        const formattedValues = res.data.data.data.map((agency) => {
          return {
            id: agency.id,
            name: agency.name,
            label: formatAgency(JSON.stringify(agency.sequence)),
            missing_documents: agency.missing_docs
              ? agency.missing_docs.join(', ')
              : '',
            'Created At': helper.timestamp(
              agency.createdAt,
              timezone
            ),
            status: agency.active ? 'Active' : 'Inactive',
          };
        });

        setDocuments(formattedValues);
      })
      .catch((err) => {
        console.log(err);

        context.notification.show(
          'There was an error while fetching the agency data. Please try again.',
          'error',
          false,
          'toast',
          'x-circle'
        );
      });

    setPageLoading(false);
    setLoading(false);
  }

  useEffect(() => {
    runAPI(page, '', true);
  }, []);

  return (
    <>
      {pageLoading ? (
        <Loader />
      ) : (
        <Animate type="pop">
          <Grid cols="1">
            <div className={styles.wrapper}>
              <div style={{ margin: 20 }}>
                <div
                  style={{
                    width: '100%',
                    marginBottom: 10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <div style={{ width: '100%', marginTop: 30 }}>
                    <Search
                      callback={(query) => {
                        setSearchQueryString(query);
                      }}
                    />
                  </div>
                </div>
                <Table
                  loading={loading}
                  data={documents}
                  badge={{
                    col: 'status',
                    condition: [
                      { value: 'Active', color: 'green' },
                      { value: 'Pending Review', color: 'purple' },
                      { value: 'Expired', color: 'red' },
                      { value: 'Archived', color: 'orange' },
                    ],
                  }}
                  hide={['id']}
                  actions={{
                    custom: [
                      {
                        icon: 'search',
                        action: (row) => {
                          window.location.href = `/admin/agency/${row.id}/documents`;
                        },
                        color: '#637381',
                        tooltip: 'View company details',
                      },
                    ],
                  }}
                />
                {!loading && payload && (
                  <Pagination
                    pagesCount={payload.pages_count}
                    active={payload.page}
                    onChange={async (newPage) => {
                      setPage(newPage);
                      runAPI(newPage, searchQueryString, false);
                    }}
                  />
                )}
              </div>
            </div>
          </Grid>
        </Animate>
      )}
    </>
  );
}
